<template>
    <QuoteDetail
        :quote="quote"
        :show="show"
        :delete-button-enabled="deleteButtonEnabled"
        :approve-button-enabled="approveButtonEnabled"
        :decline-button-enabled="declineButtonEnabled"
        @deleteQuote="destroyQuote"
        @declineQuote="modifyQuoteStatus('Declined')"
        @approveQuote="modifyQuoteStatus('Approved')"
        @update:show="$emit('update:show', $event)"
    />
</template>
<script>
import { mapActions } from "vuex";
import swal from "sweetalert2";
import QuoteDetail from "./_components/QuoteDetail";

export default {
    name: "QuoteDetailModule",
    components: { QuoteDetail },
    props: {
        quote: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loaded: false,
        };
    },
    computed: {
        deleteButtonEnabled() {
            return this.quote.status === "Submitted";
        },
        approveButtonEnabled() {
            return this.quote.status === "Pending";
        },
        declineButtonEnabled() {
            return this.quote.status === "Pending";
        },
    },
    methods: {
        ...mapActions("$_quote", ["deleteQuote", "updateQuoteStatus"]),
        async destroyQuote() {
            const { value } = await swal({
                title: "Confirm Deletion",
                text: `Are you sure you want to delete Quote #${this.quote.id}?`,
                type: "warning",
                allowEscapeKey: false,
                allowOutsideClick: false,
                reverseButtons: true,
                showConfirmButton: true,
                confirmButtonText: "Delete",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
            });
            if (value) {
                await this.deleteQuote(this.quote.id);
                this.$emit("update:show", false);
            }
        },
        async modifyQuoteStatus(status) {
            if (status === "Approved") {
                const { value } = await swal({
                    title: "Confirm Approval",
                    text: `Are you sure you want to approve Quote #${this.quote.id}?`,
                    type: "question",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    showConfirmButton: true,
                    confirmButtonText: "Approve",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                });
                if (value) {
                    await this.updateQuoteStatus({ id: this.quote.id, status });
                    swal({
                        title: "Success!",
                        text: `Quote #${this.quote.id} has been updated to Approved. A new receipt log will be created based upon this quote soon.`,
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success btn-fill",
                        type: "success",
                    }).then(() => {
                        this.$emit("update:show", false);
                    });
                }
            } else if (status === "Declined") {
                const { value } = await swal({
                    title: "Confirm Decline",
                    text: `Are you sure you want to decline Quote #${this.quote.id}?`,
                    type: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    showConfirmButton: true,
                    confirmButtonText: "Decline",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                });
                if (value) {
                    await this.updateQuoteStatus({ id: this.quote.id, status });
                    swal({
                        title: "Success!",
                        text: `Quote #${this.quote.id} has been updated to Declined.`,
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-success btn-fill",
                        type: "success",
                    }).then(() => {
                        this.$emit("update:show", false);
                    });
                }
            }
        },
    },
};
</script>
